module.exports = __webpack_public_path__ + "static/media/coffee-cup.23a33f9b.svg";